import { render, staticRenderFns } from "./AccesskeyLink.vue?vue&type=template&id=72c9f0e0"
import script from "./AccesskeyLink.vue?vue&type=script&lang=js"
export * from "./AccesskeyLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports